import { Component, EventEmitter, OnInit, Input, Output, AfterViewInit, ViewChild, ViewChildren, QueryList, ComponentFactoryResolver } from '@angular/core';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//directives
import {UCDirective} from '../../directives/UCDirective';

//interfaces


//components

@Component({
  selector: 'my-container',
  templateUrl: './Container.component.html'
    
})
export class ContainerComponent {

    constructor(private authenticationService: serv.AuthenticationService) { }

}
